<!--suppress HtmlUnknownTag, HtmlUnknownAttribute, CssUnusedSymbol -->
<template>
    <div   class="container-wrapper" element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading" v-loading="$store.state.loadingCount>0"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-container class="main-container">
            <el-header style="background-color: black">
                <el-col :span="10" style="display: flex;justify-content: start;align-items: center;padding: 0 40px">
                    <img :src="$store.state.backendHost + '/file/logo.png'"
                         style="height:40px;margin-right:20px;border-radius: 5px" alt="" ondragstart="return false">
                    <span class="title" style="font-size: large;color: #0097f2">{{ $store.state.title }}</span>
                </el-col>
                <el-col class="header-right" :span="10"
                        style="display: flex;flex-direction: row;align-items: center;justify-content: end">
                    <div style="height: 100%;display: flex;flex-direction: row;align-items: center;">
                        <div style=";margin: 0 3px;height: 80%;width: 100px" @click="navCheck(o)"
                             :class="['navItem',navs.checkedNavItem===o.route?'navItemChecked':'']"
                             v-for="(o,i) in navs.pages" :key="i">
                            {{ o.name }}
                        </div>
                        <div class="navItem" style=";margin: 0 3px;height: 80%;" @click="logOut">退出系统</div>
                    </div>
                </el-col>
            </el-header>

            <el-container :style="'padding:10px;height: '+(wh-60)+'px'">
                <el-main>
                    <el-row style="height: 5%;padding: 10px 0;background: linear-gradient(270deg, white, transparent) !important;">
                        <el-tag v-for="(tag,index) in tags" :key="tag.name" style="margin-right: 20px;cursor: pointer"
                                closable :effect="isActive(tag)?'dark':'plain'" @close="tagClose(tag,index)"
                                size="large" type="primary" @click="switchPanel(tag)">
                            {{ tag.name }}
                        </el-tag>
                    </el-row>
                    <keep-alive>
                        <transition name="fade" mode="out-in">
                            <router-view style="height: 95%"></router-view>
                        </transition>
                    </keep-alive>
                </el-main>
            </el-container>

        </el-container>
    </div>
</template>

<script>
export default {

    data() {
        return {
            ww: 0,
            wh: 0,
            user: {},
            tags: [],
            navs: {
                checkedNavItem: '',
                pages: [],
            },
            navItems: [
                {
                    name: '系统管理', icon: 'el-icon-setting',
                    childList: []
                }
            ]
        }
    },
    components: {},
    watch: {
        $route(to) {
            const tag = {name: to.name, to: to.fullPath};
            const isTagExist = this.tags.some((t) => t.name === tag.name);
            if (!isTagExist) {
                this.tags.push(tag);
            }
        }
    },
    methods: {
        navCheck(item) {
            let role = this.$store.state.loginUser.role
            if (this.$route.path !== '/' + role + '/' + item.route) {
                this.navs.checkedNavItem = item.route
                if (item.route === this.$route.path) return
                this.$router.push(item.route)
            }
        },
        switchPanel(tag) {
            if (tag.to === this.$route.path) return
            this.$router.push(tag.to)
        },
        isActive(tag) {
            return tag.to === this.$route.fullPath;
        },
        tagClose(tag, index) {
            if (tag.name !== 'users') {
                this.tags.splice(index, 1);
            }
            if (tag.name !== this.$route.name) {
                return;
            }
            const length = this.tags.length;
            if (index === length) {
                this.$router.push({name: this.tags[index - 1].name});
            } else {
                this.$router.push({name: this.tags[index].name});
            }
        },
        logOut() {
            localStorage.removeItem('user')
            this.$store.commit('setUser', null)
            this.$router.replace('/')
        }
    },
    created() {

    },
    mounted() {
        let role = this.$store.state.loginUser.role


        setTimeout(() => {
            let path = '/' + role + '/' + this.$router.options.routes[0].children[0].path
            this.$router.push(path)
        }, 10)
        this.$router.options.routes[0].children.forEach(r => {
            if (r.meta.nav) {
                this.navs.pages.push({name: r.name, route: r.path})
            }
        })
        this.navs.checkedNavItem = this.navs.pages[0].route

        this.ww = document.body.clientWidth
        this.wh = document.body.clientHeight
        window.onresize = (() => {
            this.ww = document.body.clientWidth
            this.wh = document.body.clientHeight
        })
        setTimeout(() => {
            let path = '/' + role + '/' + this.$router.options.routes[role].children[0].path
            this.$router.push(path)
        }, 10)
    }
}
</script>
<style scoped>


.el-menu-item.is-active {
    color: white !important;
    font-weight: bold !important;;
}


li.el-menu-item:hover {
    background-color: #a7a7a7;
}

.el-submenu__title:hover {
    background-color: #a7a7a7 !important;
}

li.el-menu-item.is-active {
    background-color: #a7a7a7;
}

li.el-menu-item:hover {
    color: white !important;
}

/deep/ .el-main {
    background-color: aliceblue !important;
}

/deep/ td.el-table__cell.el-table__expanded-cell {
    background-color: transparent !important;

}

/* 表格内背景颜色 */
/*/deep/ .el-table th,*/
/*/deep/ .el-table tr,*/
/*/deep/ .el-table td {*/
/*    background-color: transparent !important;*/
/*}*/
.main-container {
    /*background-color: ghostwhite;*/
}

/deep/ .el-main {
    background-color: transparent !important;
    /*z-index: 9998 !important;*/
}

/deep/ .el-header {
    /*background-color: transparent !important;*/
    /*box-shadow: 0 0 20px #00000036 !important;*/
    /*z-index: 10000;*/
}

/deep/ .el-aside {
    /*z-index: 9999 !important;*/
    box-shadow: 20px 0px 20px #0000000f !important;
    background-color: transparent !important;
}

/deep/ .el-menu {
    border: 0 !important;
    background-color: transparent !important;

}

/deep/ .table-top-wrapper {
    padding: 20px 0 !important;
    /*background: linear-gradient(270deg, rgb(79, 166, 255), transparent) !important;*/

}

/deep/ .el-pg-wrapper {
    margin-top: 20px;
    flex-direction: row;
    display: flex;
    justify-content: end;
    padding: 30px;
    background: linear-gradient(270deg, white, transparent) !important;


}

.cell {
    text-align: center !important;
}

/deep/ .navItem {
    transition-property: background-color;
    transition-duration: 0.3s;
}

/deep/ .navItem:hover {
    background-color: #0097f2;
    color: white;
}

/deep/ .navItemChecked {
    background-color: #0097f2;
    color: white;

}

</style>